import React from "react";
import Banner from "../../components/whisky_house/home/banner";
import Cards from "../../components/whisky_house/home/cards";
import Images from "../../components/whisky_house/home/images";
import CardSlide from "../../components/whisky_house/home/cardslide";
import LookingForGift from "../../components/whisky_house/home/looking_for_gift";
import { SlideData } from "../../template_codes/whisky_house/home_page";
import Header from "../../components/whisky_house/layouts/header";
const HomePage = () => {
  return (
    <div className="overflow-hidden titlefont">
      <Header SlideData={SlideData}/>
      <Banner />
      <Cards />
      <Images />
      <CardSlide SlideData={SlideData} />
      
      {/* <LookingForGift /> */}
    </div>
  );
};

export default HomePage;
